import React from 'react';

interface NetworkingIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const NetworkingIcon: React.FC<NetworkingIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#B5BCC4" fillRule="evenodd">
        <path d="M4.575 5.6a.81.81 0 0 1 1.013.534l.872 2.814a.81.81 0 0 1-1.546.48l-.872-2.814A.81.81 0 0 1 4.575 5.6Zm5.515 8.576a.81.81 0 0 1 .985-.584l2.352.602a.81.81 0 0 1-.402 1.568l-2.351-.601a.81.81 0 0 1-.584-.985ZM13.74 6.323a.81.81 0 0 1 0 1.145l-3.339 3.339a.81.81 0 0 1-1.144-1.145l3.339-3.339a.81.81 0 0 1 1.144 0Z" />
        <path d="M3.308 1.987a2.66 2.66 0 1 1 2.036 4.915 2.66 2.66 0 0 1-2.036-4.915Zm1.018 1.417a1.04 1.04 0 1 0 0 2.081 1.04 1.04 0 0 0 0-2.082ZM13.003 2.699a3.122 3.122 0 1 1 4.415 4.416 3.122 3.122 0 0 1-4.415-4.416Zm2.207.705a1.503 1.503 0 1 0 0 3.006 1.503 1.503 0 0 0 0-3.006ZM13.33 13.675a2.66 2.66 0 1 1 3.761 3.762 2.66 2.66 0 0 1-3.761-3.762Zm1.88.84a1.04 1.04 0 1 0 0 2.082 1.04 1.04 0 0 0 0-2.082ZM3.368 9.663a4.972 4.972 0 1 1 7.032 7.032 4.972 4.972 0 0 1-7.032-7.032Zm3.516.163a3.354 3.354 0 1 0 0 6.707 3.354 3.354 0 0 0 0-6.707Z" />
      </g>
    </svg>
  );
};
